// extracted by mini-css-extract-plugin
export default {"container":"Navbar_container__xEOUU","logo":"Navbar_logo__lQi2A","heading":"Navbar_heading__PSksx","button":"Navbar_button__weNC2"};